<template>
  <b-modal :id="modalId"
           :modal-class="{'modal-my-fullscreen': true, 'modal-checkout-paywithcard': true, 'modal-checkout-paywithcard--loading-pm': isLoadingPaymentMethods, 'modal-checkout-paywithcard--loading-o': isLoadingOrder}"
           centered @shown="shown" @hidden="hide"
           :no-close-on-esc="isLoadingOrder"
           :no-close-on-backdrop="isLoadingOrder">
    <!--             :hide-header="isLoading" :hide-footer="isLoading"-->
    <template slot="modal-header" variant="text-center">
      <button type="button" aria-label="Back" class="back"
              @click="activePanel = PANEL_PAYMENT_METHODS_LIST"
              v-show="!isLoading && !hasStripeError && hasPaymentMethods && activePanel === PANEL_PAYMENT_METHODS_NEW">
        {{ $t('pages.checkout.modal_payment_withcard_btn_back') }}
      </button>

      <h5 class="modal-title">{{ $t('pages.checkout.modal_payment_withcard_modal_title') }}</h5>
      <button type="button" aria-label="Close" class="close" @click="$bvModal.hide(modalId)"></button>
    </template>

    <Loader v-show="isLoadingPaymentMethods"/>

    <Loader v-show="isLoadingOrder">
      <template #message>{{ $t('pages.checkout.modal_payment_processing_text') }}</template>
    </Loader>

    <section v-if="hasStripeError" style="border: 1px solid red;padding: 20px">
      <h6>{{ $t('pages.checkout.modal_payment_processing_error_title') }}</h6>
      <!--            <p>{{ stripeError.code }}</p>-->
      <p>{{ stripeError.message }}</p>
      <!--            <p>{{ stripeError.doc_url }}</p>-->
    </section>

    <div class="payment-methods-list"
         v-show="!isLoading && !hasStripeError && activePanel === PANEL_PAYMENT_METHODS_LIST">
      <h4>{{ $t('pages.checkout.modal_payment_withcard_card_list_title') }}</h4>
      <PaymentMethodItem v-for="(pm, index) in paymentMethods" :key="index"
                         :pm="pm"
                         :defaultPaymentMethodId="paymentMethodDefault"
                         :selectedPaymentMethodId="paymentMethodSelected"
                         @paymentmethod-selected="selectPaymentMethod"
                         @set-default-clicked="setDefaultPaymentMethod"
                         @remove-clicked="removePaymentMethod"/>
      <b-button variant="outline-primary" block @click="activePanel = PANEL_PAYMENT_METHODS_NEW">
        {{ $t('pages.checkout.modal_payment_withcard_new_card') }}
      </b-button>
    </div>

    <div class="payment-method-new" v-show="!isLoading && !hasStripeError && activePanel === PANEL_PAYMENT_METHODS_NEW">
      <div>
        <label for="card-element">{{ $t('pages.checkout.modal_payment_withcard_label') }}</label>
        <div id="card-element">
          <!-- A Stripe Element will be inserted here. -->
        </div>
        <!-- Used to display form errors. -->
        <div id="card-errors" class="text-danger pt-2"></div>

      </div>
    </div>

    <div class="row mt-3" v-show="!isLoading && !hasStripeError">
      <div class="col-md-8" v-if="countries">
        <div class="form-group">
          <label for="">{{ $t('shipping_address_fields.country_of_residence') }}</label>
          <multiselect
              id="addressCountry" name="addressCountry"
              :data-vv-as="$t('shipping_address_fields.country')" v-validate="'required'"
              :placeholder="$t('shipping_address_fields.country_placeholder')"
              track-by="code"
              :options="countries"
              v-model="addressCountry"
              :custom-label="(opt) => `${opt.code} ${opt.name}`"
              :show-labels="false">
            <template slot="singleLabel" slot-scope="{ option }">
              <strong>{{ option.name }}</strong>
            </template>

            <template slot="option" slot-scope="{ option }">
              <strong>{{ option.name }}</strong>
            </template>
            <span slot="noResult">No country found</span>
          </multiselect>
        </div>
        <span v-show="errors.has('addressCountry')" class="field-error">{{ errors.first('addressCountry') }}</span>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label for="addressPostalCode">{{ $t('shipping_address_fields.zip_code') }}</label>
          <input type="text" id="addressPostalCode" name="addressPostalCode" v-model="addressPostalCode"
                 :data-vv-as="$t('shipping_address_fields.zip_code')" v-validate="{ required: true, max: 10 }"
                 class="form-control form-control--cap">
        </div>
      </div>

      <div class="col-md-12">
        <span v-show="errors.has('addressPostalCode')" class="field-error">{{
            errors.first('addressPostalCode')
          }}</span>
      </div>


    </div>

    <div v-show="!isLoading && !hasStripeError && activePanel === PANEL_PAYMENT_METHODS_NEW">
      <b-form-checkbox
          class="card-save"
          id="checkbox-save-card"
          v-model="saveCard"
          name="checkbox-save-card"
          value="true"
          unchecked-value="false">
        {{ $t('pages.checkout.modal_payment_withcard_save_new_card') }}
      </b-form-checkbox>
    </div>

    <PaymentWithCardInfos class="pb-0" :selected-payment-method="PAYMENT_METHOD_CARD"/>

    <template slot="modal-footer">
      <b-button block variant="primary" class="btn--pay" size="md" @click="pay"
                v-show="!hasStripeError" :disabled="isLoadingOrder">
        {{ $tc('pages.checkout.action_stripe_pay') }}
        {{ totalCartItems.grand_total|formatCurrency(totalCartItems.currency) }}
      </b-button>
      <b-button block size="md" @click="hide" v-if="hasStripeError">
        {{ $t('pages.checkout.modal_payment_withcard_close') }}
      </b-button>
    </template>
  </b-modal>
</template>


<script>
import Multiselect from "vue-multiselect"

import {PAYMENT_METHOD_CARD} from "@/consts.js"
import UserService from "@/services/User.js"
import Loader from "@/components/Loader"
import PaymentMethodItem from "@/components/PaymentMethodItem"
import PaymentWithCardInfos from "@/components/PaymentWithCardInfos"
import CartService from "@/services/Cart"
import {mapGetters, mapMutations} from "vuex";

const PANEL_PAYMENT_METHODS_LIST = 'pm-list'
const PANEL_PAYMENT_METHODS_NEW = 'pm-new'


export default {
  components: {
    Multiselect,
    Loader,
    PaymentMethodItem,
    PaymentWithCardInfos
  },

  props: {
    modalId: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      activePanel: PANEL_PAYMENT_METHODS_NEW,
      isLoadingPaymentMethods: true,
      isLoadingOrder: false,
      cardElement: null,
      paymentMethods: [],
      paymentMethodDefault: null,
      paymentMethodSelected: null,
      countries: [],
      addressCountry: '',
      addressPostalCode: '',
      fullName: '',
      saveCard: 'false',
      stripeError: {},
    }
  },

  created() {
    this.PAYMENT_METHOD_CARD = PAYMENT_METHOD_CARD
    this.PANEL_PAYMENT_METHODS_LIST = PANEL_PAYMENT_METHODS_LIST
    this.PANEL_PAYMENT_METHODS_NEW = PANEL_PAYMENT_METHODS_NEW
  },

  computed: {
    ...mapGetters('cartDigitalItems', ['totalCartItems']),
    hasPaymentMethods() {
      return this.paymentMethods.length > 0
    },

    hasStripeError() {
      return Object.keys(this.stripeError).length > 0
    },

    isLoading() {
      return this.isLoadingPaymentMethods || this.isLoadingOrder
    }
  },

  mounted() {
    CartService.getCountries().then(response => {
      this.countries = response.data
    })
  },

  methods: {
    ...mapMutations('cartDigitalItems', ['resetCart']),
    resetData() {
      this.activePanel = PANEL_PAYMENT_METHODS_NEW
      this.isLoadingPaymentMethods = true
      // cardElement: null,
      // paymentMethods: [],
      this.paymentMethodDefault = null
      this.paymentMethodSelected = null
      this.saveCard = 'false'
      this.stripeError = {}
      this.orderId = null
    },

    shown() {
      this.initComponent()
      this.setupStripe()
    },

    hide() {
      this.resetData()
      this.$bvModal.hide(this.modalId)
    },

    initComponent() {
      console.log('initComponent')
      this.isLoadingPaymentMethods = true
      UserService.getPaymentMethods()
          .then(response => {
            this.paymentMethods = response.data.data

            if (this.hasPaymentMethods) {
              this.activePanel = PANEL_PAYMENT_METHODS_LIST

              const paymentMethodDefault = this.paymentMethods.find(paymentMethod => paymentMethod.is_default_payment_method === true)
              if (paymentMethodDefault) {
                this.paymentMethodDefault = paymentMethodDefault.id
                this.selectPaymentMethod(paymentMethodDefault.id)
              }
            } else {
              this.activePanel = PANEL_PAYMENT_METHODS_NEW
            }

            this.isLoadingPaymentMethods = false
            // this.showCardForm = this.paymentMethods.length === 0
          })
    },

    setupStripe() {
      console.log('setupStripe')
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)
      const elements = this.stripe.elements()
      this.cardElement = elements.create('card', {
        hidePostalCode: true,
        style: {
          base: {
            color: '#00001A',
            fontWeight: '600',
            fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif',
            fontSize: '1.1rem',
          },
        }
      })
      // Add an instance of the card Element into the `card-element` <div>.
      this.cardElement.mount('#card-element')
      this.cardElement.addEventListener('change', function (event) {
        let displayError = document.getElementById('card-errors')
        if (event.error) {
          displayError.textContent = event.error.message
        } else {
          displayError.textContent = ''
        }
      })
    },

    setDefaultPaymentMethod(paymentMethodId) {
      UserService.setDefaultPaymentMethod(paymentMethodId)
          .then(response => {
            this.paymentMethodDefault = paymentMethodId
          })
    },

    selectPaymentMethod(paymentMethodId) {
      this.paymentMethodSelected = paymentMethodId
      const paymentMethod = this.paymentMethods.find(i => i.id === paymentMethodId)
      this.addressCountry = this.countries.find(i => i.code === paymentMethod.billing_details.address.country)
      this.addressPostalCode = paymentMethod.billing_details.address.postal_code
    },

    removePaymentMethod(paymentMethodId) {
      UserService.removePaymentMethod(paymentMethodId)
          .then(response => {
            console.log('removePaymentMethod response', response)
            let updated = this.paymentMethods.filter(item => paymentMethodId !== item.id)
            this.$set(this, 'paymentMethods', updated)
            // this.paymentMethods = Object.assign({}, this.paymentMethods, updated)
          })
    },

    async validateCard() {
      // barbatrucco per forzare la validazione del form client side, senza cioè passara dal payment intent
      return this.stripe.createToken(this.cardElement)
    },

    async pay() {
      await this.$validator.validate() // force validation for country and postal code
      if (this.addressPostalCode === '' || this.addressCountry === '') {
        return false
      }
      this.stripeError = {}
      this.isLoadingOrder = true

      let payload = {
        paymentMethod: PAYMENT_METHOD_CARD,
        billingAddress: {
          country: this.addressCountry.code,
          postal_code: this.addressPostalCode
        }
      }

      if (this.activePanel === PANEL_PAYMENT_METHODS_LIST) {
        if (!this.paymentMethodSelected) {
          // mostra errore 'seleziona un metodo di pagamento'
          this.isLoadingOrder = false
          return false
        }
        payload.paymentMethodId = this.paymentMethodSelected
      } else if (this.activePanel === PANEL_PAYMENT_METHODS_NEW) {
        const validationResult = await this.validateCard()
        if (validationResult.error) {
          var errorElement = document.getElementById('card-errors')
          errorElement.textContent = validationResult.error.message
          this.isLoadingOrder = false
          return false
        }
      }

      this.$store.dispatch("cart/placeOrder", payload)
          .then(response => {
            const orderId = response.data.order_id

            let handleCardPaymentArgs = [response.data.client_secret]
            let handleCardPaymentArgsData = {}

            if (this.activePanel === PANEL_PAYMENT_METHODS_NEW) {
              console.log('panel new')
              // l'utente ha inserito un nuovo payment method dal form
              handleCardPaymentArgs.push(this.cardElement)

              handleCardPaymentArgsData.payment_method_data = {
                billing_details: {
                  address: {
                    country: this.addressCountry.code,
                    postal_code: this.addressPostalCode
                  },
                }
              }
              if (this.saveCard === 'true') {
                handleCardPaymentArgsData.save_payment_method = true
              }
            } else if (this.activePanel === PANEL_PAYMENT_METHODS_LIST) {
              // l'utente ha selezionato un paymentmethod già salvato
              handleCardPaymentArgsData.payment_method = this.paymentMethodSelected
            }
            handleCardPaymentArgs.push(handleCardPaymentArgsData)
            // come pagare con una carta già salvata
            // https://stripe.com/docs/payments/cards/charging-saved-cards#submit-payment
            this.stripe.handleCardPayment(...handleCardPaymentArgs)
                .then(result => {
                  if (result.error) {
                    // Display error.message in your UI.
                    console.log('stripe error', result.error)
                    this.stripeError = result.error
                  } else {
                    // The payment has succeeded. Display a success message.
                    console.log('stripe success', result)
                    this.$store.dispatch("cart/emitFbPixelPurchaseEvent", {
                      currency: result.paymentIntent.currency,
                      amount: result.paymentIntent.amount / 100
                    })
                    this.resetCart()
                    this.$emit('order-success', orderId)
                  }
                })
                .finally(() => {
                  this.isLoadingOrder = false
                })
          })
    }
  }
}
</script>
